var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 92,
    viewBox: "0 0 79 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.999985,
    y: 39,
    width: 77,
    height: 52,
    stroke: "#FF6702"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999985 39L39.5 1L78 39",
    stroke: "#FF6702"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999985 40L39.15 76L78 40",
    stroke: "#FF6702"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999985 91L30 67",
    stroke: "#FF6702"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91L49 67",
    stroke: "#FF6702"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4ddc7f49.svg";
export { ForwardRef as ReactComponent };